import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatSort } from '@angular/material';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { CandidateComponent } from '../candidate/candidate.component';
import { UploadExcelComponent } from '../upload-excel/upload-excel.component';
import { CandidateService } from 'src/app/shared/candidate.service';
import { Candidate } from 'src/app/model/candidate.model';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Http } from '@angular/http';
import { ApiService } from 'src/app/shared/api.service';
import { Headers, RequestOptions } from '@angular/http';
import * as XLSX from 'xlsx';
import { NotificationService } from 'src/app/shared/notification.service';
import { DialogService } from 'src/app/shared/dialog-service/dialog.service';
import { interval, Subscription} from 'rxjs';

@Component({
  selector: 'app-candidate-list',
  templateUrl: './candidate-list.component.html',
  styleUrls: ['./candidate-list.component.scss']
})
export class CandidateListComponent implements OnInit {
 
  mySubscription: Subscription;
  filterName: string;
  listData: MatTableDataSource<any>;
  private candidates: Candidate[];
  uploadForm: FormGroup;
  DialogRef: MatDialogRef<CandidateComponent>;
  XlDialogRef: MatDialogRef<UploadExcelComponent>;
  candidateListLoader: Boolean;

  private candidateJson: String;
  private apiDomain = ApiService.getDomainName();
  private eventId = this.apiService.getEventId();

  displayedColumns: string[] = ['candidateName', 'email', 'contactNo', 'address', 'gender', 'dob', 'attemptStatus', 'totalMarks', 'score', 'actions'];

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private http: Http,
    private candidteService: CandidateService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private dialogService: DialogService,
    private formBuilder: FormBuilder,
    private apiService: ApiService
  ) { 
    this.candidateListLoader = false;
  //   this.mySubscription= interval(1000).subscribe((result =>{
  //     this.updateCountDown();
  // }));
  }

  ngOnInit() {

    //csv, excel uploads
    this.getAllCandidate();
    this.uploadForm = this.formBuilder.group({
      candidateFile: ['']
    });
  }

  ngOnDestroy() {
    if(this.mySubscription)
    this.mySubscription.unsubscribe();
  }
  public startingMinutes = .10;
  public time = this.startingMinutes * 50;
  public syncButtonEnabler = true;

  updateCountDown() {
    let minutes = Math.floor(this.time/50);
    let seconds = this.time % 50;
    this.syncButtonEnabler = false;
    // console.log('>>>>>>>>>>>', minutes, seconds);

    if (minutes > 0 || seconds > 0){
      if (minutes < 10 && seconds < 10) {
        document.getElementById("myTimer").innerHTML = `0${minutes}:0${seconds}`;
      }
      else if (minutes < 10 && seconds >= 10) {
        document.getElementById("myTimer").innerHTML = `0${minutes}:${seconds}`;
      }
      else if (minutes >=10 && seconds < 10) {
        document.getElementById("myTimer").innerHTML = `${minutes}:0${seconds}`;
      }
      else {
        document.getElementById("myTimer").innerHTML = `${minutes}:${seconds}`;
      }
    }
    else {
      this.mySubscription.unsubscribe();
      this.startingMinutes=.10;
      document.getElementById("myTimer").innerHTML = `00.05`;
      document.getElementById("remaining-label").innerHTML = `Remaining`;
      this.syncButtonEnabler = true;
      this.time = this.startingMinutes * 50;
    }

    this.time--;

  }

  getAllCandidate() {
    this.candidateListLoader = true;
    this.candidteService.findAll().then(
      candidates => {
        this.candidateListLoader = false;
        this.candidates = candidates;
        if (this.candidates && (this.candidates.length != 0)) {
          this.listData = new MatTableDataSource(candidates);
          this.listData.sort = this.sort;
          this.listData.paginator = this.paginator;
        }
      },
      err => {
        this.candidateListLoader = false;
        console.error(err);
      }
    );
  }

  syncCandidates() {
    this.mySubscription= interval(1000).subscribe((result =>{
          this.updateCountDown();
      }));
    this.candidateListLoader = true;
    this.candidteService.loadCandidatesFromParentSystem()
      .then(response => {
        this.candidateListLoader = false;
        this.getAllCandidate();
        this.notificationService.success(response);
      })
      .catch(error => {
        this.candidateListLoader = false;
        const { errors } = error;
        if (errors && Array.isArray(errors) && errors.length) {
          this.notificationService.warn(
            errors.map(e => (e && e.message) || "").filter(e => e !== '').join(', ') || 'Failed to Sync Candidates'
          )
        }
      });
  }

  addToCandiateList(data) {
    const candidates = this.candidates;
    
    if (this.candidates && (this.candidates.length != 0)) {
      this.listData = new MatTableDataSource([
        ...data,
        ...candidates
      ]);
      this.listData.sort = this.sort;
      this.listData.paginator = this.paginator;
      this.candidates = Object.assign([], this.listData.data);
    } else {
      this.candidates = Object.assign([], data);
      this.listData = new MatTableDataSource(this.candidates);
      this.listData.sort = this.sort;
      this.listData.paginator = this.paginator;
    }
  }
  updateToCandiateList(data) {
    let candidates = this.candidates;
    
    if (this.candidates.length != 0) {
      candidates = candidates
                    .map(candidateRecord => 
                      (candidateRecord.candidateId == data.candidateId)
                        ? ({
                            ...candidateRecord,
                            ...data
                          })
                        : Object.assign(candidateRecord)
                    );
                    
      this.listData = new MatTableDataSource(candidates);
      this.listData.sort = this.sort;
      this.listData.paginator = this.paginator;
      this.candidates = Object.assign([], this.listData.data);
    } else {
      this.candidates = Object.assign([], data);
      this.listData = new MatTableDataSource(this.candidates);
      this.listData.sort = this.sort;
      this.listData.paginator = this.paginator;
    }
  }
  applyFilter(filterValue: string) {
    this.listData.filter = filterValue.trim().toLowerCase();
  }
  onClear() {
    this.listData.filter = '';
    this.filterName = '';
    this.notificationService.success('Cleared');
  }

  onCreate() {
    const dialogConfig = {
      disableClose: true,
      autoFocus: true,
      width: "60%",
    };
    this.DialogRef = this.dialog.open(CandidateComponent, dialogConfig);
    const subscribeRef = this.DialogRef
                          .componentInstance
                          .updateCandiateList
                          .subscribe(data => this.addToCandiateList(data));
    this.DialogRef.afterClosed().subscribe(() => {
      subscribeRef.unsubscribe();
    })
  }

  onUpload() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "40%";
    this.XlDialogRef = this.dialog.open(UploadExcelComponent, dialogConfig);
    const subscribeRef = this.XlDialogRef
                            .componentInstance
                            .updateCandiateList
                            .subscribe(data => this.addToCandiateList(data));

    this.XlDialogRef.afterClosed().subscribe(() => {
      subscribeRef.unsubscribe();
    });
  }

  onEdit(rowId) {
    for (let candidate of this.candidates) {
      if (candidate['candidateId'] == rowId) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = "60%";
        this.candidteService.form.controls['id'].setValue(candidate['candidateId']);
        this.candidteService.form.controls['candidateName'].setValue(candidate['candidateName']);
        this.candidteService.form.controls['gender'].setValue(candidate['gender']);
        this.candidteService.form.controls['email'].setValue(candidate['email']);
        this.candidteService.form.controls['contactNo'].setValue(candidate['contactNo']);
        this.candidteService.form.controls['address'].setValue(candidate['address']);
        this.candidteService.form.controls['dob'].setValue(new Date(candidate['dob']));
        this.candidteService.form.controls['totalMarks'].setValue(candidate['totalMarks']);
        this.candidteService.form.controls['score'].setValue(candidate['score']);
        this.candidteService.form.controls['attemptStatus'].setValue(candidate['attemptStatus']);
        
        this.DialogRef = this.dialog.open(CandidateComponent, dialogConfig);
        const subscribeRef = this.DialogRef
                                .componentInstance
                                .updateCandiateList
                                .subscribe(data => this.updateToCandiateList(data));

        this.DialogRef.afterClosed().subscribe(() => {
          subscribeRef.unsubscribe();
        })
      }
    }
  }

  onDelete(rowId) {
    this.dialogService.openConfirmDialog('Are you sure to delete this record ?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.candidteService.deleteCandidate(rowId)
              .then(data => {
                this.candidates = this.candidates.filter(candidateRecord => (candidateRecord.candidateId != data.candidateId ));
                this.listData = new MatTableDataSource(this.candidates);
                this.listData.sort = this.sort;
                this.listData.paginator = this.paginator;
                this.notificationService.success('Deleted successfully');
              }).catch(err => {
                this.notificationService.warn(err);
              });
        }
      });
  }

  csvInputChange(files) {
    // var files = fileInputEvent.target.files; // FileList object
    if(!(files[0].name.indexOf(".xlsx") > 0)){
      this.notificationService.warn('Only .xlsx & .xls extensions file can be acceptable');
      return false;
    }
    this.parseExcel(files[0]);
  }

  parseExcel(file) {
    var reader = new FileReader();
    reader.onload = (e) => {
      var data = (<any>e.target).result;
      var workbook = XLSX.read(data, {
        type: 'binary'
      });
      workbook.SheetNames.forEach((function (sheetName) {
        // Here is your object
        var XL_row_object = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { raw: false });
        var json_object = JSON.stringify(XL_row_object);
        this.createCandidate(XL_row_object).then(
          res => {
            const { listOfRejectedCandidates, listOfSavedCandidates, message } = res && res.data;
            this.notificationService.success(message || 'File uploaded Successfully');
            window.location.reload();
          },
          err => {
            const { data, errors } = err;
            const { listOfRejectedCandidates } = data;

            errors.forEach(errorObj => {
              const { message } = errorObj;
              this.notificationService.warn(message || 'Failed to upload');
            });
            
            listOfRejectedCandidates.forEach(candidateObj => {
              candidateObj.listOfErrorMessageAssociated.forEach(errorMessage => {
                this.notificationService.warn(errorMessage);
              })
            });
            return false;
          }
        );
        // console.debug(json_object)
        //this.gridObj.dataSource = JSON.parse(json_object);
      }).bind(this), this);
    }

    reader.onerror = function (ex) {
      console.debug(ex);
    }
    reader.readAsBinaryString(file);
    // console.debug
  }

  createCandidate(json_object) {
    let candidateHeaders = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.post(this.apiDomain + "/ims/api/" + this.eventId + "/candidate/", json_object, { headers: candidateHeaders })
      .toPromise()
      .then(response => response as any)
      .catch(this.handleError);
  }
  private handleError(error: any)  {
    console.error('An error occurred', error);
    try {
       const errorJSON = error && error.json();
      if ( errorJSON.httpCode == 401 ) {
        ApiService.sessionExpireRedirection();
      }
      return Promise.reject(errorJSON);
    } catch(err) {
      return Promise.reject(error && error.message);
    }
  }
  copyToClipboard(text: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = text;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox); 

    this.notificationService.success("Copied to clipboard");
  }
}
